import { useCallback } from "react";
import { useEnvironmentState } from "../context";
import { useFetch } from "./useFetch";

export function useUploadAttachment(
  onUploaded?: (attachment: { id: string; name?: string }) => void
) {
  const { backendBaseUrl } = useEnvironmentState();

  const [fetch, { data, loading, error }] = useFetch<{
    id: string;
    name?: string;
  }>(`${backendBaseUrl}/attachment/upload`, {
    onFetchSuccess: onUploaded,
  });

  const computeAttachmentUrl = useCallback(
    (id: string) => {
      return `${backendBaseUrl}/attachment/${id}`;
    },
    [backendBaseUrl]
  );

  const uploadAttachment = useCallback(
    (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return fetch({
        method: "POST",
        body: formData,
      });
    },
    [fetch]
  );

  return { uploadAttachment, computeAttachmentUrl, data, loading, error };
}
